import {NgModule} from '@angular/core';
import {CharacterMaskPipe} from './character-mask.pipe';
import {FormatPipe} from './format.pipe';
import {NonBreakingPipe} from '@raven';
import {PhonePipe} from './phone.pipe';
import {CustomPluralPipe} from './plural.pipe';
import {ReplaceEmptyPipe} from './replace-empty.pipe';
import {YesOrNoPipe} from './yes-or-no.pipe';

@NgModule({
  declarations: [
    CharacterMaskPipe,
    FormatPipe,
    NonBreakingPipe,
    PhonePipe,
    CustomPluralPipe,
    ReplaceEmptyPipe,
    YesOrNoPipe,
  ],
  exports: [
    CharacterMaskPipe,
    FormatPipe,
    NonBreakingPipe,
    PhonePipe,
    CustomPluralPipe,
    ReplaceEmptyPipe,
    YesOrNoPipe,
  ],
  providers: [
    CharacterMaskPipe,
    FormatPipe,
    NonBreakingPipe,
    PhonePipe,
    CustomPluralPipe,
    ReplaceEmptyPipe,
    YesOrNoPipe,
  ],
})
export class FormatPipeModule {
}
